import { Avatar, Button, Dialog, DialogActions, DialogContent, Grid, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box } from '@mui/system';

import { numberFormat, satoshiFormatter } from 'helpers/i18n';

const ConfirmationDialog = ({ open, currentValues, errorMessage, onGoBackClick, onConfirmClick, isLoading }) => {
    return (
        <Dialog open={open} onClose={() => {}} maxWidth="lg">
            <DialogContent sx={{ width: '605px', padding: '32px 40px' }}>
                <Grid container>
                    <Grid item xs={2} sx={{ textAlign: 'center' }}>
                        <Avatar sx={{ bgcolor: '#F7F8F9' }}>
                            <ErrorOutlineIcon sx={{ color: '#FF9E43' }} />
                        </Avatar>
                    </Grid>
                    <Grid item xs={10}>
                        <Typography className="dialog-title">Are you sure you want to approve request?</Typography>
                        <Box>
                            <Typography className="text-secondary">
                                Assigned spend limit: {numberFormat(currentValues.spend_limit)} - Satoshis:{' '}
                                {satoshiFormatter(currentValues.satoshi_amount)} ({satoshiFormatter(currentValues.reward_rate)}
                                %)
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
                {errorMessage && (
                    <Typography className="text-error">
                        There was an error trying to approve the applicant. {errorMessage}
                    </Typography>
                )}
                <DialogActions sx={{ marginTop: '54px' }}>
                    <Button
                        variant="outlined"
                        sx={{ color: '#7D95A5', borderColor: '#7D95A5' }}
                        onClick={onGoBackClick}
                        disabled={isLoading}>
                        Go Back
                    </Button>

                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: '#FF9E43',
                            borderColor: '#FF9E43'
                        }}
                        disabled={isLoading}
                        onClick={onConfirmClick}>
                        Confirm
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default ConfirmationDialog;
